import React from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { H5, H6, LI, OL, UL } from '../../../../AbstractElements';
import { FontawesomeList, ICOIconList, ListingTypography, Listrtext, OrderList, ThemfyList, UnorderList } from '../../../../Constant';
import OrderListCol from './OrderListCol';

const ListCard = () => {
  let ULtypography = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  let List = [1, 2, 3, 4, 5, 6, 7, 8];
  return (
    <Col sm='12 listing'>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{ListingTypography}</H5>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm='12' xl='4'>
              <H6 className='sub-title'>{UnorderList}</H6>
              <UL as='ul' className='mb-3 simple-list'>
                {ULtypography.map((item, index) => {
                  return <LI key={index}>{Listrtext}</LI>;
                })}
              </UL>
            </Col>
            <Col sm='12' xl='4'>
              <H6 className='sub-title'>{OrderList}</H6>
              <OL className='d-block simple-list'>
                <LI val={Listrtext} />
                <LI val={Listrtext} />
                <LI val={Listrtext} />
                <LI>
                  <OL className='d-block simple-list'>
                    <LI val={Listrtext} />
                    <LI val={Listrtext} />
                    <LI val={Listrtext} />
                    <LI val={Listrtext} />
                    <LI val={Listrtext} />
                  </OL>
                </LI>
                <LI val={Listrtext} />
                <LI val={Listrtext} />
              </OL>
            </Col>
            <OrderListCol/>
            <Col sm='12' xl='4'>
              <H6 className='sub-title'>{FontawesomeList}</H6>
              <UL as='ul' className='simple-list'>
                {List.map((item, index) => {
                  return (
                    <LI key={index}>
                      <i className='fa fa-angle-double-right txt-primary m-r-10'></i>
                      {Listrtext}
                    </LI>
                  );
                })}
              </UL>
            </Col>
            <Col sm='12' xl='4'>
              <H6 className='sub-title'>{ICOIconList}</H6>
              <UL as='ul' className='simple-list'>
                {List.map((item, index) => {
                  return (
                    <LI key={index}>
                      <i className='fa fa-caret-right txt-secondary m-r-10'></i>
                      {Listrtext}
                    </LI>
                  );
                })}
              </UL>
            </Col>
            <Col sm='12' xl='4'>
              <H6 className='sub-title'>{ThemfyList}</H6>
              <UL as='ul' className='simple-list'>
                {List.map((item, index) => {
                  return (
                    <LI key={index}>
                      <i className='icofont icofont-ui-rate-add txt-success m-r-10'></i>
                      {Listrtext}
                    </LI>
                  );
                })}
              </UL>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ListCard;
